import { createSelector } from 'reselect';

export const Types = {
  GET_REQUEST: 'regions/GET_REQUEST',
  GET_SUCCESS: 'regions/GET_SUCCESS',
  GET_FAILURE: 'regions/GET_FAILURE',

  GET_LIST_REQUEST: 'regions/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'regions/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'regions/GET_LIST_FAILURE',

  CREATE_REQUEST: 'regions/CREATE_REQUEST',
  CREATE_SUCCESS: 'regions/CREATE_SUCCESS',
  CREATE_FAILURE: 'regions/CREATE_FAILURE',

  UPDATE_REQUEST: 'regions/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'regions/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'regions/UPDATE_FAILURE',

  DELETE_REQUEST: 'regions/DELETE_REQUEST',
  DELETE_SUCCESS: 'regions/DELETE_SUCCESS',
  DELETE_FAILURE: 'regions/DELETE_FAILURE',

  GET_PLACES_REQUEST: 'regions/GET_PLACES_REQUEST',
  GET_PLACES_SUCCESS: 'regions/GET_PLACES_SUCCESS',
  GET_PLACES_FAILURE: 'regions/GET_PLACES_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },

  places: {
    data: [],
    loading: false,
  },
};

export default function regions(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.Region.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.regions.data,
        page: action.payload.regions.meta.current_page,
        totals: action.payload.regions.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.DELETE_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true,
        },
      };
    case Types.DELETE_SUCCESS:
    case Types.DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
        },
      };
    case Types.GET_PLACES_REQUEST:
      return {
        ...state,
        places: {
          ...state.places,
          loading: true,
        },
      };
    case Types.GET_PLACES_SUCCESS:
      return {
        ...state,
        places: {
          ...state.places,
          loading: false,
          data: action.payload.places.data,
        },
      };
    case Types.GET_PLACES_FAILURE:
      return {
        ...state,
        places: {
          ...state.places,
          loading: false,
        }
      };
    default:
      return state;
  }
}

export const Creators = {
  getRegionRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getRegionSuccess: Region => ({
    type: Types.GET_SUCCESS,
    payload: { Region },
  }),

  getRegionFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getRegionsRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getRegionsSuccess: regions => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { regions },
  }),

  getRegionsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createRegionRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createRegionSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createRegionFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateRegionRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateRegionSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateRegionFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteRegionRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteRegionSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deleteRegionFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),

  getRegionPlacesRequest: (query = null) => ({
    type: Types.GET_PLACES_REQUEST,
    payload: { query },
  }),

  getRegionPlacesSuccess: places => ({
    type: Types.GET_PLACES_SUCCESS,
    payload: { places },
  }),

  getRegionPlacesFailure: () => ({
    type: Types.GET_PLACES_FAILURE,
  }),
};

export const Selectors = {
  places: createSelector(
    state => state,
    places => places.map(place => ({ value: place.id, label: place.attributes.name })),
  ),
}
